import { PENDING_CHECKOUT_STORAGE } from 'Utils/const/localstorage'

// Lightweight, per-browser record that a Stripe checkout was started but not yet
// confirmed as active. Lets the app show an "activating…" state instead of a
// stale "Starter" plan while the webhook / status check catches up.

export const setPendingCheckout = ({ sessionId, period }) => {
  try {
    localStorage.setItem(PENDING_CHECKOUT_STORAGE, JSON.stringify({ sessionId, period, at: Date.now() }))
  } catch {
    // storage unavailable (private mode, disabled) — pending UI just won't show
  }
}

export const getPendingCheckout = () => {
  try {
    return JSON.parse(localStorage.getItem(PENDING_CHECKOUT_STORAGE)) || null
  } catch {
    return null
  }
}

export const clearPendingCheckout = () => {
  try {
    localStorage.removeItem(PENDING_CHECKOUT_STORAGE)
  } catch {
    // nothing to clear
  }
}
